
<rms-mod height="86vh" width="98%">
  <rms-table [HeaderButtons]="HeaderButtons" 
    [columns]="RatesColumns"
    [data]="OrginRatesList"

    [DragAndDrop]="true"
    [DragDropLabel]="'Drag/Drop New Rates or click to select file'"
    [DragAccept]="'.xlsx,.xls'"
    [DragMultiple]="false"
    (fileDropped)="onRatesFileDropped($event)"
    [icons]="Icons">
  </rms-table>
</rms-mod>
